import { useEffect, useState } from "react";
import { Headphones, Minus, TrendingDown, TrendingUp } from "lucide-react";
import { api } from "../../lib/api";

// Insights In App: which activities each child listened to most this week —
// same data as the weekly digest's Listening Favorites section.
export const ListeningFavorites = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/recap/listening").then(({ data: d }) => setData(d)).catch(() => setData({ rows: [], labels: {} }));
  }, []);

  if (!data || !data.rows.length) return null;

  return (
    <div className="bg-card rounded-2xl border border-border p-5 space-y-3" data-testid="listening-favorites-panel">
      <h3 className="text-sm font-bold font-display flex items-center gap-2">
        <Headphones className="h-4 w-4 text-secondary" aria-hidden="true" />
        Listening favorites this week
      </h3>
      <ul className="space-y-2">
        {data.rows.map((row) => (
          <li key={row.child_id} className="text-sm" data-testid={`listening-row-${row.child_id}`}>
            <span className="font-bold">{row.name}:</span>{" "}
            <span
              className={`inline-flex items-center gap-0.5 text-[11px] font-bold rounded-full px-1.5 py-0.5 align-middle mr-1 ${
                row.trend === "up" ? "bg-emerald-100 text-emerald-700"
                  : row.trend === "down" ? "bg-amber-100 text-amber-700"
                  : "bg-muted text-muted-foreground"}`}
              title={row.trend === "same" ? "Same as last week" : `${row.delta_minutes} min ${row.trend === "up" ? "more" : "less"} than last week`}
              data-testid={`listening-trend-${row.child_id}`}
            >
              {row.trend === "up" ? <TrendingUp className="h-3 w-3" aria-hidden="true" />
                : row.trend === "down" ? <TrendingDown className="h-3 w-3" aria-hidden="true" />
                : <Minus className="h-3 w-3" aria-hidden="true" />}
              {row.trend !== "same" && `${row.delta_minutes}m`}
            </span>
            <span className="text-muted-foreground">
              {row.items.map((i) => `${data.labels[i.key] || i.key} ${i.minutes} min`).join(" · ")}
            </span>
          </li>
        ))}
      </ul>
      <p className="text-[11px] text-muted-foreground">
        Adds up to each child's cap-counted voice minutes — story time doesn't count toward the cap.
      </p>
    </div>
  );
};
